export const SELECT_COMPANY_DIALOG = 'react-select-company-dialog';
export const selectCompDataTestId = 'select-company-input';
export const selectPrivDataTestId = 'select-privilege-input';
export const licenseSectionDataTestId = 'licensed-to-section';
export const confirmBtnDataTestId = 'select-company-confirm-btn';
